// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"264":"series","353":"contact","450":"dynamic","594":"about"}[chunkId] + "." + {"264":"436cc96c","353":"958f6f54","450":"3e13650a","594":"6077f652"}[chunkId] + ".css";
};